/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { editReport, getClientReportsData } from 'state/actions/reportsState/reports_status';
import { saveReport, updateReport, runReport, downloadReport, saveAndRunReport, discardReportChanges } from 'state/actions/reportsState/selected_report_status';
import { sendErrorMessage } from '@insticator/insticator-ui';
// component
import ReportControls from 'pages/dashboard/reports/reportcontrols/reportcontrols';



/* ========== ~~~~~~~~~~ CONTROLS FOOTER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ appStatus, reportsState, sessionStatus }) => ({
    currentPage: appStatus.currentPage,
    userFirstName: sessionStatus.userFirstName,
    accountUUID: sessionStatus.accountUUID,
    isDataReceived: reportsState.reportsStatus.isDataReceived,
    selectedReportData: reportsState.selectedReportStatus.selectedReportData,
    saveReportPending: reportsState.selectedReportStatus.status.saveReportPending,
    isReportSaved: reportsState.selectedReportStatus.status.isReportSaved,
    reportDownloading: reportsState.selectedReportStatus.reportDownloading,
    reportRunning: reportsState.selectedReportStatus.status.runReportPending,
    reportChangeDetected: reportsState.selectedReportStatus.status.reportChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    editReport: reportUUID => dispatch(editReport(reportUUID)),
    saveReport: (reportData, successRoute) => dispatch(saveReport(reportData, successRoute)),
    updateReport: (reportUUID, reportData, successRoute) => dispatch(updateReport(reportUUID, reportData, successRoute)),
    runReport: (reportData, successRoute) => dispatch(runReport(reportData, successRoute)),
    getClientReportsData: accountUUID => dispatch(getClientReportsData(accountUUID)),
    sendErrorMessage: text => dispatch(sendErrorMessage(text)),
    downloadReport: (data, reportType) => dispatch(downloadReport(data, reportType)),
    saveAndRunReport: (reportData, reportUUID, accountUUID) => dispatch(saveAndRunReport(reportData, reportUUID, accountUUID)),
    discardReportChanges: () => dispatch(discardReportChanges())
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportControls);
